import LabelIcon from '@mui/icons-material/LabelOutlined';
import BarChartIcon from '@mui/icons-material/InsertChartOutlined';
import BookmarkIcon from '@mui/icons-material/BookmarkBorderOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';

export const AMFI_TYPES = ['attribute', 'metric', 'fact', 'insight'];

export const AMFI_CONFIG = {
  attribute: {
    color: '#27A4F9', // Sky blue
    icon: <LabelIcon />,
    displayName: 'Attribute',
  },
  metric: {
    color: '#008077', // Pine green
    icon: <BarChartIcon />,
    displayName: 'Metric',
  },
  fact: {
    color: '#F7BD00', // Goldenrod
    icon: <BookmarkIcon />,
    displayName: 'Fact',
  },
  insight: {
    color: '#5759EE', // Indigo
    icon: <InfoIcon />,
    displayName: 'Insight',
  },
};

// Helper function to get the plural form of the display name
const getPluralDisplayName = (type) => {
  const baseName = AMFI_CONFIG[type]?.displayName || type;
  return `${baseName}s`;
};

export const getAmfiConfig = (type) => ({
  ...AMFI_CONFIG[type],
  pluralDisplayName: getPluralDisplayName(type),
});
